import { render } from "./StationedShip.vue?vue&type=template&id=64ac6140"
import script from "./StationedShip.vue?vue&type=script&lang=js"
export * from "./StationedShip.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/tooltips/troops/StationedShip.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64ac6140"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64ac6140', __exports__)) {
    api.reload('64ac6140', __exports__)
  }
  
  module.hot.accept("./StationedShip.vue?vue&type=template&id=64ac6140", () => {
    api.rerender('64ac6140', render)
  })

}


export default __exports__